import { AboutContentRow } from '@/modules/content-blocks/interfaces';

export const createDefaultAboutContentRow = (): AboutContentRow => ({
   id: crypto.randomUUID(),
   title: {},
   description: {},
   image: {
      alt_text: null,
      id: null,
      url: null,
      name: null,
   },
   image_id: null,
   imageLeft: false,
});
